'use client';

import React from 'react';

import { Caption } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import { useAppBadgesMethods } from '../AppBadge/useAppBadgesMethods';
import { ExtendedLink } from '../ExtendedLink';

import styles from './styles.module.css';

import { APP_STORE_URL } from '@/modules/branch/constants';
import { DeviceType } from '@/modules/device/types';
import { useUserAgent } from '@/modules/device/useUserAgent';

export function DownloadTheAppBadgeMobile() {
  const t = useTranslations('common');
  const { getIosAppBadge, getAndroidAppBadge, handleBadgeClick } =
    useAppBadgesMethods();
  const { device } = useUserAgent();

  const { badge: iosBadge, href: iosHref } = getIosAppBadge();
  const { badge: androidBadge, href: androidHref } = getAndroidAppBadge();

  function getAppDownloadLink() {
    switch (device) {
      case DeviceType.IOS:
        return iosHref;
      case DeviceType.ANDROID:
        return androidHref;
      default:
        return APP_STORE_URL;
    }
  }
  return (
    <ExtendedLink
      href={getAppDownloadLink()}
      onClick={() => handleBadgeClick(device, 'make_offer_modal')}
      className={styles.appDownloadBox}
    >
      <img
        src={`${process.env.NEXT_PUBLIC_DEPOP_CLOUDFRONT_HOST}/web/assets/depop-logo-white.png`}
        alt=""
        className={styles.appDownloadLogo}
      />
      <div>
        <div className={styles.appDownloadBadgeText}>
          <Caption variant="lg-bold" colour="base">
            {t('DownloadTheAppBadge.Title')}
          </Caption>
          <Caption colour="base">{t('DownloadTheAppBadge.Body')}</Caption>
        </div>
        <div className={styles.downloadAppBadges}>
          {iosBadge}
          {androidBadge}
        </div>
      </div>
    </ExtendedLink>
  );
}
